module.exports = __webpack_public_path__ + "img/组织机构.cf571dab.png";